import request from '@/utils/ajax';


export function deleteWxFans(data){
  return request({
    url: `/wx/manage/wxUser/delete`,
    method: 'post',
    data: data,
  });
}
